export default __webpack_public_path__ + "static/media/j.a0e0b5af.svg";